











































import {Mixins, Prop} from "vue-property-decorator";
import Component from "vue-class-component";
import {Style, Widget, WidgetParameters} from "@/components/dashboard/Dashboard.vue";
import Container from "@/components/dashboard/widgets/Container.vue";
import DashboardMixin from "@/mixins/dashboard/DashboardMixin";
import _ from "lodash";

const components = {
    Container,
};

interface ImageLinkParameters extends WidgetParameters {
    imageUrl?: string;
    cta?: {
        label: string;
        url?: string;
        route?: string;
        openInNewTab?: boolean;
    };
}

interface ImageLinkData extends Widget {
    parameters: ImageLinkParameters;
}

@Component({components})
export default class ImageLink extends Mixins(DashboardMixin) {
    @Prop({default: null}) public widget !: ImageLinkData;

    protected get hasCta(): boolean {
        return _.get(this.widget.parameters, "cta", false) && (this.isUrlLink || this.isRouteLink);
    }

    protected get isUrlLink(): boolean {
        return _.get(this.widget.parameters, "cta.url", false);
    }

    protected get isRouteLink(): boolean {
        return _.get(this.widget.parameters, "cta.route", false);
    }

    protected get containerStyle(): Style {
        return {
            padding: 0,
        };
    }

    protected goToCta(): void {
        if (this.isUrlLink && this.widget?.parameters?.cta?.url) {
            if (this.widget?.parameters?.cta?.openInNewTab === false || !_.has(this.widget.parameters.cta, "openInNewTab")) {
                window.location.href = this.widget.parameters.cta.url;
            } else {
                window.open(this.widget.parameters.cta.url, "_blank");
            }
        } else if (this.isRouteLink && this.widget?.parameters?.cta?.route) {
            this.$router.push(this.widget.parameters.cta.route);
        }
    }
}
